import React from "react";
import { useState } from "react";
import styles from "./component.module.scss";


/**
 * Zugriff von aussen mit
 * 
 * const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
 * 
 * const handleFilesChange = (files: File[]) => {
 *   setUploadedFiles(files);
 * };
 * 
 * <UploadContainer onFilesChange={handleFilesChange} />
 *  
 * {uploadedFiles.map((file, index) => (
 *    {file.name}
 * ))}
 * 
 */
interface FileUploadProps {
  onFilesChange?: (files: File[]) => void; // Callback-Prop
}

const UploadContainer: React.FC<FileUploadProps> = ({ onFilesChange }) => {
  const [files, setFiles] = useState<File[]>([]);
  const [previews, setPreviews] = useState<string[]>([]); // Speichert Bild-URLs

  const updateFiles = (newFiles: File[]) => {
    const updatedFiles = [...files, ...newFiles];
    setFiles(updatedFiles);
    if (onFilesChange) {
      onFilesChange(updatedFiles);
    }

    // Erstelle Vorschauen mit Object URL
    const newPreviews = newFiles.map((file) => URL.createObjectURL(file));
    setPreviews([...previews, ...newPreviews]);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      updateFiles(Array.from(event.target.files));
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (event.dataTransfer.files) {
      updateFiles(Array.from(event.dataTransfer.files));
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const removeFile = (index: number) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
    setPreviews(previews.filter((_, i) => i !== index));

    if (onFilesChange) {
      onFilesChange(updatedFiles);
    }
  };

  const isImage = (file: File): boolean => {
    return file.type.startsWith("image/");
  };

  return (
    <div className="p-4 border-2 border-dashed rounded-lg w-96">
      <div
        className="p-6 text-center bg-gray-100 rounded-md cursor-pointer"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <p>Ziehe deine Dateien hierher oder</p>
        <label className="text-blue-500 underline cursor-pointer">
          Durchsuchen
          <input type="file" multiple className="hidden" onChange={handleFileChange} />
        </label>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '3fr 3fr 3fr', columnGap: "10px" }}>
        {previews.map((src, index) => (

          <div className={styles["uploadFileCard"]} >

            <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr', columnGap: "10px" }}>

              <div>
                {( isImage(files[index])) ?
                  < img src={src} width={100} />
                  :
                  <div>Keine Vorschau</div>
                }
              </div>
              <div>

                <p style={{ textAlign: "right"}}>
                  <button className="btn btn-danger" onClick={() => removeFile(index)}><i className="bi bi-trash" /></button>
                </p>

                <p style={{ fontSize: "10pt" }}>{files[index]?.name}</p>

              </div>

            </div>
          </div>
        ))}
      </div>

    </div>
  );
}

export default UploadContainer;